<div class="splash" #splash>
  <div *ngIf="!this.pauseGif">
    <img class="splash-gif" alt="Splash Image" (load)="this.loadImgComplete($event)" [src]="imgString" #img>
    <!-- <div class="splashImage" [ngStyle]="{'background-image': 'url('+ imgString +')'}" #img></div> -->
  </div>
  <div *ngIf="this.pauseGif">
    <img alt="Splash Image" style="width: 85%; max-width: 551px;" src="assets/logo/logo-pedeaqui-white.png">
  </div>
</div>
